import React from 'react';
import ReactDOM from 'react-dom';
import Items from './Items';

const SectionWiseItem = (props) => {

    let SET = 0;
    let j = 0;
    return (
            props.sections.map((post, i)=>{
               
                //console.log('=>');
                //console.log(props.selectedSECTION);
                //console.log('<=');
                //console.log(j);
                let vegonly = localStorage.getItem('vegONLY') || 'N';
                
                let PRINT = 'Y';
                if(vegonly=='Y' && post.veg==0)
                {
                    PRINT = 'N';
                    if(props.selectedSECTION!='' && props.selectedSECTION!='0' && props.selectedSECTION!='undefined'  && props.selectedSECTION!=undefined && props.selectedSECTION==post.id)
                        SET++;
                }
                else if(vegonly!='Y' && post.veg==0 && post.nonveg==0)
                {
                    PRINT = 'N';
                    if(props.selectedSECTION!='' && props.selectedSECTION!='0' && props.selectedSECTION!='undefined'  && props.selectedSECTION!=undefined && props.selectedSECTION==post.id)
                        SET++;
                }

				{/*<div className="custom-control custom-checkbox mb-1">
                    <input defaultChecked={vegonly=='Y'?true:false} onChange={props.handleVegOnlyChecked} type="checkbox" className="custom-control-input" id="chkVeg">
                    <label className="custom-control-label" htmlFor="chkVeg">VEG ONLY</label>
                </div>*/}

                if(props.selectedSECTION!='' && props.selectedSECTION!='0' && props.selectedSECTION!='undefined'  && props.selectedSECTION!=undefined && props.selectedSECTION!=post.id)
                    PRINT = 'N';

                if(j==0 && PRINT=='Y')
                {
                    j++;
                    return (
                        <div className="section full mt-2 mb-2" key={post.id} id={post.id}>
                            <div className="row" style={{'width': '100%'}}>
                                <div className="col-6">
                                    <div className="section-title">{post.name}</div>
                                </div>
                                <div className="col-6" style={{'textAlign': 'right'}}>
                                    {/*<div className="custom-control custom-switch rggt" > VEG ONLY &nbsp;
                                        <input defaultChecked={vegonly=='Y'?true:false} onChange={props.handleVegOnlyChecked} type="checkbox" className="custom-control-input" id="chkVeg" style={{ height: "10px" }}/>
                                        &nbsp;
                                        <label className="custom-control-label" htmlFor="chkVeg"></label>
                                    </div>*/}
                                    <div className="custom-control custom-checkbox mb-1">
                                        <input defaultChecked={vegonly=='Y'?true:false} onChange={props.handleVegOnlyChecked} type="checkbox" className="custom-control-input" id="chkVeg" />
                                        <label className="custom-control-label veg-only-box" htmlFor="chkVeg">VEG ONLY</label>
                                    </div>
                                </div>
                            </div>
                            <ul className="listview image-listview media">
                                <Items sec_id={post.id} items={props.items} veg_only={props.vegonly} inCartCallBack={props.inCartCallBack} CLOSED={props.CLOSED} OPENS={props.OPENS}/>
                            </ul>
                        </div>
                    )
                }
                else if(PRINT=='Y')
                {
                    j++;
                    return (
                        <div className="section full mt-2 mb-2" key={post.id} id={post.id}>
                            <div className="section-title">{post.name}</div>
                            <ul className="listview image-listview media">
                                <Items sec_id={post.id} items={props.items} veg_only={props.vegonly} inCartCallBack={props.inCartCallBack} CLOSED={props.CLOSED} OPENS={props.OPENS}/>
                            </ul>
                        </div>
                    )
                }

                if(SET==1 && props.selectedSECTION==post.id)
                {
                    return (
                        <div className="section full mt-2 mb-2" key={post.id} id={post.id}>
                            <div className="row" style={{'width': '100%'}}>
                                <div className="col-6">
                                    <div className="section-title">{post.name}</div>
                                </div>
                                <div className="col-6" style={{'textAlign': 'right'}}>
                                    {/*<div className="custom-control custom-switch rggt" > VEG ONLY &nbsp;
                                        <input defaultChecked={vegonly=='Y'?true:false} onChange={props.handleVegOnlyChecked} type="checkbox" className="custom-control-input" id="chkVeg" style={{ height: "10px" }}/>
                                        &nbsp;
                                        <label className="custom-control-label" htmlFor="chkVeg"></label>
                                    </div>*/}
                                    <div className="custom-control custom-checkbox mb-1">
                                        <input defaultChecked={vegonly=='Y'?true:false} onChange={props.handleVegOnlyChecked} type="checkbox" className="custom-control-input" id="chkVeg" />
                                        <label className="custom-control-label veg-only-box" htmlFor="chkVeg">VEG ONLY</label>
                                    </div>
                                </div>
                            </div>
                            <div class="section-title"><br />No dish found</div>
                        </div>
                    )
                }
            })
    );
}
  
export default SectionWiseItem;


// WEBPACK FOOTER //
// ./src/components/SectionWiseItem.js